// VERSION 1: Grundläggande scrollhantering vid navigering mellan sidor
// Sparar scrollposition per URL i en karta, återställer vid återbesök

// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const scrollPositions = new Map();

// function ScrollManager() {
//     const { pathname } = useLocation();

//     useEffect(() => {
//         // återställ scroll när vi landar på ny sida
//         if (scrollPositions.has(pathname)) {
//             window.scrollTo(0, scrollPositions.get(pathname));
//         } else {
//             window.scrollTo(0, 0); // ny sida → börja högst upp
//         }

//         const saveScroll = () => {
//             scrollPositions.set(pathname, window.scrollY);
//         };

//         window.addEventListener("scroll", saveScroll);
//         return () => window.removeEventListener("scroll", saveScroll);
//     }, [pathname]);

//     return null;
// }

// export default ScrollManager;

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollManager() {
    const { pathname } = useLocation();

    useEffect(() => {
        // varje gång route ändras → scrolla upp
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default ScrollManager;

